<template>
  <div class="navbar navbar-primary">
    <div class="container">
      <!-- Logo -->
      <a class="navbar-brand" href="/">
        <img class="logo logo-dark" alt="Sundry Group" src="../assets/img/sundry_food_logo.png">
      </a>
      <!-- #end Logo -->
      <div class="navbar-header">
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#mainnav"
          aria-expanded="false">
          <span class="sr-only">Menu</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <!-- Q-Button for Mobile -->
        <div class="quote-btn"><a class="btn sundry-red-bg" href="#openings">Apply Now</a></div>
      </div>
      <!-- MainNav -->
      <nav class="navbar-collapse collapse" id="mainnav">
        <ul class="nav navbar-nav">
          <li><a href="/">HOME</a></li>
          <li><a href="/contact">CONTACT</a></li>
          <li class="quote-btn"><a class="btn sundry-red-bg" href="/#openings">Apply Now</a></li>
        </ul>
      </nav>
      <!-- #end MainNav -->
    </div>
  </div>
</template>
<style scoped>
  .navbar {
    position: fixed;
    z-index: 99;
    width: 100% !important;
  }
</style>
<script>
  export default {
    name: 'Menu'
  }
</script>